import appsNavigationConfig from './apps.navigation.config'
import wearitNavigationConfig from './wearit.navigation.config'
import uiComponentNavigationConfig from './ui-components.navigation.config'
import pagesNavigationConfig from './pages.navigation.config'
import authNavigationConfig from './auth.navigation.config'
import docNavigationConfig from './doc.navigation.config'
import features from '../features'

// Dashboard Redesign, Phase 1: the new 9-workspace "operating system" sidebar
// replaces the flat APPS tree when NEW_NAV is enabled. Every route is preserved
// either way — this only changes grouping. Flip the flag to fall back instantly.
const navigationConfig = [
    ...(features.NEW_NAV ? wearitNavigationConfig : appsNavigationConfig),
    // ...uiComponentNavigationConfig,
    // ...pagesNavigationConfig,
    // ...authNavigationConfig,
    // ...docNavigationConfig,
]

export default navigationConfig
